import React, { Component } from "react";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import Autocompletesearch from "../2/Controls/Autocompletesearch";
import { getProperty } from "../../CommonFunctions";

class AddEditFeedbackLink extends Component {
    constructor() {
        super();
        this.state = {
            feedbackTemplateId: "",
            feedbackTemplates: [],
            validityFrom: new Date().toISOString().split('T')[0],
            validityTo: new Date().toISOString().split('T')[0],
            key: "",
            feedbackTemplateIdError: "",
            customerTypeAheadOptions: [],
            isCustomerTypeAheadLoading: false,
            isSalesTypeAheadLoading: false,
            saving: false,
            isActive: false,
            selectedCustomer: null,
            selectedSales: null,
            customerSearchValue: "",
            salesSearchValue: "",
            salesTypeAheadOptions: []
        };
        this.onSave = this.onSave.bind(this);
        this.loadFeedbacks = this.loadFeedbacks.bind(this);
        this.onCustomerSearch = this.onCustomerSearch.bind(this);
        this.onCustomerSelect = this.onCustomerSelect.bind(this);
        this.onSalesSearch = this.onSalesSearch.bind(this);
        this.onSalesSelect = this.onSalesSelect.bind(this);
    }

    loadFeedbacks = async () => {
        try {
            this.setState({ saving: true });
            let response = await this.props.getFeedbacks();
            let list = [];

            if (response.code === "0") {
                list = response.data;
            } else {
                alert("Failed to fetch feedback");
                list = [];
            }

            this.setState({ feedbackTemplates: list });
        }
        catch (err) {
            alert("Failed to fetch feedback");
        }
        finally {
            this.setState({ saving: false });
        }
    }

    onCustomerSearch(query) {
        this.setState({
            isCustomerTypeAheadLoading: true,
            customerSearchValue: query,
            selectedCustomer:{},
        });

        this.props
            .searchCustomer(
                this.props.user.user.RegistrationID,
                this.props.user.store.key,
                query
            )
            .then((result) => {
                this.setState({
                    customerTypeAheadOptions: result.searchResult || [],
                    isCustomerTypeAheadLoading: false
                });
            })
            .catch((error) => {
                console.error("Customer search error:", error);
                this.setState({
                    customerTypeAheadOptions: [],
                    isCustomerTypeAheadLoading: false
                });
            });
    }

    onSalesSearch(query) {
        this.setState({
            isSalesTypeAheadLoading: true,
            salesSearchValue: query,
            selectedSales:{}
        });

        const searchParam = query;

        this.props.getSalesHistory(
            0,
            50,
            null,
            this.props.user.store.key,
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            searchParam
        )
            .then((result) => {
                this.setState({
                    salesTypeAheadOptions: result.sales || [],
                    isSalesTypeAheadLoading: false
                });
            })
            .catch((error) => {
                console.error("Sales search error:", error);
                this.setState({
                    salesTypeAheadOptions: [],
                    isSalesTypeAheadLoading: false
                });
            });
    }

    onSalesSelect(sale) {
        this.setState({
            selectedSales: {
                TransactionNo: getProperty(sale, "TransactionNo"),
                TransactionID: getProperty(sale, "key"),
            },
            salesSearchValue: sale ? sale.TransactionNo : ""
        });
    }

    onCustomerSelect(customer) {
        this.setState({
            selectedCustomer: {
                FirstName: getProperty(customer, "FirstName"),
                LastName: getProperty(customer, "LastName"),
                PhoneNo: getProperty(customer, "PhoneNo"),
                EmailID: getProperty(customer, "EmailID"),
                key: getProperty(customer, "key")
            },
            customerSearchValue: customer ? `${customer.FirstName} ${customer.LastName}` : ""
        });
    }

    componentDidMount() {
        this.loadFeedbacks();
        if (this.props.editData) {
            const data = this.props.editData;
            
            // Set customer data if available
            let selectedCustomer = null;
            let customerSearchValue = "";
            if (data.Customer) {
                selectedCustomer = {
                    FirstName: getProperty(data.Customer, "FirstName"),
                    LastName: getProperty(data.Customer, "LastName"),
                    PhoneNo: getProperty(data.Customer, "PhoneNo"),
                    EmailID: getProperty(data.Customer, "EmailID"),
                    key: getProperty(data.Customer, "key")
                };
                customerSearchValue = `${data.Customer.FirstName || ''} ${data.Customer.LastName || ''}`.trim();
            }

            // Set sales data if available
            let selectedSales = null;
            let salesSearchValue = "";
            if (data.Order) {
                selectedSales = {
                    TransactionNo: getProperty(data.Order, "TransactionNo"),
                    TransactionID: getProperty(data.Order, "key"),
                };
                salesSearchValue = data.Order.TransactionNo || "";
            }

            this.setState({
                feedbackTemplateId: data.FeedbackTemplateID || "",
                validityFrom: data.ValidityFrom || this.state.validityFrom,
                validityTo: data.ValidityTo || this.state.validityTo,
                isActive: data.IsActive || false,
                key: data.key || "",
                selectedCustomer: selectedCustomer,
                selectedSales: selectedSales,
                customerSearchValue: customerSearchValue,
                salesSearchValue: salesSearchValue
            });
        }
    }

    async onSave() {
        let feedbackTemplateIdError = "";

        if (this.state.feedbackTemplateId.trim() === "") {
            this.setState({ feedbackTemplateIdError: "Please select template", saving: false });
            return;
        }

        

        this.setState({ saving: true });

        const payload = {
            Customer: this.state.selectedCustomer,
            Order: this.state.selectedSales,
            IsActive: this.state.isActive,
            StoreID: this.props.user.store.key,
            ValidityFrom: this.state.validityFrom,
            ValidityTo: this.state.validityTo,
            FeedbackTemplateID: this.state.feedbackTemplateId,
            WhiteLabelCode: this.props.config.WhiteLabel.Code
        }
        try {
            const response = await this.props.saveFeedbackLink(this.state.key, payload);

            if (response.code === "0") {
                alert("Feedback saved successfully");

                if (this.state.key === "" && response.link) {
                    this.props.onLinkGenerated(response.link);
                    this.props.onClose();
                    return;
                }

                this.props.onSave();
            } else {
                alert("Failed to save");
            }
        } catch (error) {
            alert("Failed to save");
            console.log("error", error);
        } finally {
            if (this.state.key !== "") {
                this.setState({ saving: false });
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <Window
                    header={this.state.key !== "" ? "Edit" : "New"}
                    onButtonClick={(action) => {
                        if (action.toLowerCase() === "save") {
                            this.onSave();
                        } else {
                            this.props.onClose();
                        }
                    }}
                    buttons={[
                        { Type: "secondary", Text: "Cancel", Align: "left" },
                        { Type: "primary", Text: "Save", Align: "right" },
                    ]}
                    processing={this.state.saving}
                    onClose={() => this.props.onClose()}
                    slide={true}
                >
                    <Input
                        isMandatory={true}
                        type="select"
                        label="Template"
                        value={this.state.feedbackTemplateId}
                        onChange={(value) =>
                            this.setState({
                                feedbackTemplateId: value,
                                feedbackTemplateIdError: ""
                            })
                        }
                        error={this.state.feedbackTemplateIdError}
                    >
                        <option value="">Select Template</option>
                        {this.state.feedbackTemplates.filter(
                            (f) => !f.IsDeleted
                        ).map((template) => (
                            <option key={template.key} value={template.key}>
                                {template.Title}
                            </option>
                        ))}
                    </Input>
                    <div className="row">
                         <div className="col-md-12" style={{marginBottom:"10px"}}>
                        <Autocompletesearch
                            label="Customer"
                            placeholder="Search customer by name, email or phone"
                            value={this.state.customerSearchValue}
                            data={this.state.customerTypeAheadOptions}
                            filterKey={['FirstName', 'LastName', 'PhoneNo', 'EmailID']}
                            defaultDataCount={5}
                            onChange={this.onCustomerSearch}
                            onSelect={this.onCustomerSelect}
                            showSideLoader={this.state.isCustomerTypeAheadLoading}
                            renderSuggestion={(item) => (
                                <div>
                                    <div>
                                        <div>
                                            <p>
                                                {item.FirstName} {item.LastName}
                                            </p>
                                        </div>
                                        {item.PhoneNo && (
                                            <p style={{ margin: 0 }}>{item.PhoneNo}</p>
                                        )}
                                        {item.EmailID && (
                                            <p style={{ margin: 0 }}>{item.EmailID}</p>
                                        )}
                                    </div>
                                </div>
                            )}
                        />
                        </div>
                    </div>
                    <div className="row">
                         <div className="col-md-12" style={{marginBottom:"10px"}}>
                        <Autocompletesearch
                            label="Order"
                            placeholder="Search by transaction no"
                            value={this.state.salesSearchValue}
                            data={this.state.salesTypeAheadOptions}
                            filterKey={['TransactionNo']}
                            defaultDataCount={5}
                            onChange={this.onSalesSearch}
                            onSelect={this.onSalesSelect}
                            showSideLoader={this.state.isSalesTypeAheadLoading}
                            renderSuggestion={(item) => (
                                <div>
                                    <div>
                                        <div>
                                            <p>
                                                {item.TransactionNo}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        />
                        </div>
                    </div>
                    <div className="row">
                         <div className="col-md-12">
                        <Input
                            type="switch"
                            label="Active"
                            value={this.state.isActive}
                            onChange={(e) => {
                                this.setState({
                                    isActive: e
                                });
                            }}
                        />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Input
                                type="date"
                                label="Validity from"
                                value={this.state.validityFrom}
                                onChange={(value) => this.setState({ validityFrom: value })}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Input
                                type="date"
                                label="Validity To"
                                value={this.state.validityTo}
                                onChange={(value) => this.setState({ validityTo: value })}
                            />
                        </div>
                    </div>
                </Window>
            </React.Fragment>
        );
    }
}

export default AddEditFeedbackLink;